import React, { useState } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button
} from '@mui/material';
import { GetGrooupStudentActivityDataAPI } from '../../Conections/AcademicConection';
import { useNavigate, useParams } from 'react-router-dom';

// Datos de ejemplo





function EstudentActivityGrade() {

  const goTo = useNavigate();
  const params = useParams();

  const [studentName, setStudentName] = useState("");

  const [studentData, setStudentData] = useState({
    id: 0,
    codigo: '',
    nombre: '',
    apellido: '',
    email: ''
  });

  const [actividadData, setActividadData] = useState({
    nombre: '',
    descripcion: '',
    peso: 0,
    nota: 0
  });

  const [subactividades, setSubactividades] = useState([]);
  const [puntos, setPuntos] = useState([]);
  const [bonos, setBonos] = useState([]);

  React.useEffect(() => {
    async function reloaduser() {
      let Activity = await GetGrooupStudentActivityDataAPI(params["clave"], params["student"], params["activity"]);

      let estudianteEjemploD = studentData;
      setStudentName(Activity["firstname"]);
      estudianteEjemploD.id = Activity["id"];
      estudianteEjemploD.codigo = Activity["code"];
      estudianteEjemploD.nombre = Activity["firstname"];
      estudianteEjemploD.apellido = Activity["lastname"];
      estudianteEjemploD.email = Activity["email"];
      setStudentData(estudianteEjemploD);

      if (Activity && Activity.data && Activity.data.length > 0) {
        setSubactividades(Activity.data[0].subactividades);
        setActividadData(Activity.data[0].activity);
        setPuntos(Activity.data[0].puntos);
        setBonos(Activity.data[0].bonos);
        console.log(subactividades.length);
      }

    };
    reloaduser();
  }, [params, studentData, studentName]);


  const handleConsultarSubactividad = (id) => {
    console.log(`Consultando subactividad con ID: ${id}`);
    goTo("/academic/estudentactivitygrade/" + params["clave"] + "/" + params["student"] + "/" + id);
    // Aquí iría la lógica para mostrar más detalles de la subactividad
  };

  return (
    <Container maxWidth="lg" className="py-8">
      <Typography variant="h4" component="h1" gutterBottom align="center" className="mb-6 text-primary">
        Notas de la Actividad
      </Typography>

      <Grid container spacing={3} direction="column">
        {/* Datos del Estudiante */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom className="text-blue-900">
                Datos del Estudiante
              </Typography>
              <Typography><strong>Código:</strong> {studentData.codigo}</Typography>
              <Typography><strong>Nombre:</strong> {studentData.nombre}</Typography>
              <Typography><strong>Apellido:</strong> {studentData.apellido}</Typography>
              <Typography><strong>Email:</strong> {studentData.email}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Datos de la Actividad */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom className="text-blue-900">
                Datos de la Actividad
              </Typography>
              <Typography><strong>Nombre:</strong> {actividadData.nombre}</Typography>
              <Typography><strong>Descripción:</strong> {actividadData.descripcion}</Typography>
              <Typography><strong>Fecha:</strong> {actividadData.fecha}</Typography>
              <Typography><strong>Peso[50]:</strong> {actividadData.peso}%</Typography>
              <Typography><strong>Nota:</strong> {actividadData.nota}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Subactividades */}
        {subactividades.length > 0 ? (
          <Grid item xs={12}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-blue-900">
                  Subactividades
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell align="right">Peso</TableCell>
                        <TableCell align="right">Fecha</TableCell>
                        <TableCell align="right">Nota<br/>[0-50]</TableCell>
                        <TableCell align="center">Acción</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {subactividades.map((subactividad) => (
                        <TableRow key={subactividad.id}>
                          <TableCell component="th" scope="row">
                            {subactividad.nombre}
                          </TableCell>
                          <TableCell align="right">{subactividad.peso}</TableCell>
                          <TableCell align="right">{subactividad.fecha}</TableCell>
                          <TableCell align="right">{subactividad.nota}</TableCell>
                          <TableCell align="center">
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => handleConsultarSubactividad(subactividad.id)}
                            >
                              Consultar
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          <div></div>
        )}

        {/* Puntos */}
        {puntos.length > 0 ? (
          <Grid item xs={12}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-blue-900">
                  Puntos
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell align="right">Peso</TableCell>
                        <TableCell align="right" >Razon</TableCell>
                        <TableCell align="right">Nota<br/>[0-100]</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {puntos.map((punto, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {punto.nombre}
                          </TableCell>
                          <TableCell align="right">{punto.peso}</TableCell>
                          <TableCell align="right">{punto.razon}</TableCell>
                          <TableCell align="right">{punto.nota}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          <div></div>
        )}

        {/* Bonos */}
        {bonos.length > 0 ? (
          <Grid item xs={12}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-blue-900">
                  Bonos
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell align="right">Valor</TableCell>
                        <TableCell align="right">Nota</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bonos.map((bono, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {bono.nombre}
                          </TableCell>
                          <TableCell align="right">{bono.valor}</TableCell>
                          <TableCell align="right">{bono.nota}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          <div></div>
        )}
      </Grid>
    </Container>
  );
}

export default EstudentActivityGrade;

